import { useTranslation } from 'react-i18next';

function BatterSeasonRecordComponent({record, leagueType}) {
    const { t } = useTranslation();
    let recordString = '';

    if(leagueType === 4201) {
        recordString += (record['basicStat_gameCnt'] || 0);
        recordString += t('game') + " ";
        recordString += (record['basicStat_tpa'] || 0);
        recordString += t('pa') + ' ';
        recordString += `${record['avg']}/${record['obp']}/${record['slg']}`;
    } else {
        recordString += (record['gameCnt'] || 0);
        recordString += t('game') + " ";
        recordString += (record['pa'] || 0);
        recordString += t('pa') + ' ';
        recordString += `${record['avg'] || '-'}/${record['obp'] || '-'}/${record['slg'] || '-'}`;
    }

    return (
        <>
            <div className="dataRow">
                {recordString}
            </div>
            <div className="dataTable">
                <table>
                    <thead>
                        <tr>
                            <th>{t('hit')}</th>
                            <th>{t('hr')}</th>
                            <th>{t('rbi')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                        leagueType === 4201
                        ?
                        <tr>
                            <td>{record['basicStat_hit']}</td>
                            <td>{record['basicStat_hr']}</td>
                            <td>{record['basicStat_rbi']}</td>
                        </tr>
                        :
                        <tr>
                            <td>{record['hit']}</td>
                            <td>{record['hr']}</td>
                            <td>{record['rbi']}</td>
                        </tr>
                        }   
                        <tr>
                            <th>{t('so')}</th>
                            <th>{t('bb')}</th>
                            <th>{t('sb')}</th>
                        </tr>
                        {
                        leagueType === 4201
                        ?
                        <tr>
                            <td>{record['basicStat_so']}</td>
                            <td>{record['basicStat_bb'] ? record['basicStat_bb']+record['basicStat_ibb'] : 0}</td>
                            <td>{record['basicStat_sbSucc']}</td>
                        </tr>
                        :
                        <tr>
                            <td>{record['so']}</td>
                            <td>{record['bb'] ? record['bb']*1+record['ibb']*1 : 0}</td>
                            <td>{record['sb']}</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default BatterSeasonRecordComponent;